module.exports = __webpack_public_path__ + "img/sv30.dfecb7ff.svg";